import { ReactNode } from "react";
import clsx from "clsx";

export default function MaxWidthWrapper({ className, children }: { className?: string; children: ReactNode }) {
  return (
    <div className={clsx("mx-auto w-full max-w-[1400px] px-4 lg:px-12 xl:px-16 2xl:px-20 ", className)}>{children}</div>
  );
}
